var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStoreMarkerIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 49,
    viewBox: "0 0 44 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "mapMarkerIcon",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "mapMarkerIcon"
  }, "Map Marker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "mapMarkerIcon"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_636_1930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 48.5964C34.1503 48.5964 44 46.9433 44 44.9041C44 42.8649 34.1503 41.2118 22 41.2118C9.84974 41.2118 0 42.8649 0 44.9041C0 46.9433 9.84974 48.5964 22 48.5964Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 19.058C38.5 31.9811 22 43.058 22 43.058C22 43.058 5.5 31.9811 5.5 19.058C5.5 14.6513 7.23839 10.4252 10.3327 7.30916C13.4271 4.19317 17.6239 2.44263 22 2.44263C26.376 2.44263 30.5729 4.19317 33.6673 7.30916C36.7616 10.4252 38.5 14.6513 38.5 19.058Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 24.5965C25.0377 24.5965 27.5 22.1169 27.5 19.058C27.5 15.9992 25.0377 13.5195 22 13.5195C18.9623 13.5195 16.5 15.9992 16.5 19.058C16.5 22.1169 18.9623 24.5965 22 24.5965Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_636_1930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 48,
    fill: "white",
    transform: "translate(0 0.596436)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStoreMarkerIcon);
export default ForwardRef;